module.exports = __webpack_public_path__ + "static/media/OP_IPSA_Main_Logo.974b1290.svg";